import type { LOCALE } from '../types';
import enUs from './locales/en-us';
import zhCn from './locales/zh-cn';

type I18nMessages = Record<string, string>;
type I18nKey = keyof typeof enUs;

const LOCALE_MAP: Record<string, I18nMessages> = {
  en: enUs,
  'en-us': enUs,
  zh: zhCn,
  'zh-cn': zhCn,
};

export class I18nManager {
  private locale: string;

  constructor(locale: LOCALE | string) {
    this.locale = locale;
  }

  setLocale(locale: string): void {
    this.locale = locale;
  }

  t(key: I18nKey): string {
    const messages = LOCALE_MAP[this.locale] ?? LOCALE_MAP['en'];
    return messages[key] ?? key;
  }
}
